import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';




@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent {

  updateform: UntypedFormGroup;
  fullData:any
  firstname:any;
  lastname:any;
  email1:any;
  phonenumber:any;
  showOverlay=false;
  imageURL:any;
  selectedFile:any;
  username:any;
  img_path:any;
  userProfileImage: string = 'assets/images/users/avatar-2.jpg'; 
  constructor(private router: Router, 
    private authService: AuthenticationService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private _shared:SharedService,
    private http: HttpClient
    ){

  }

  ngOnInit(): void {

    this.fullData = JSON.parse(localStorage.getItem('fullData') || '[]');
    this.firstname = this.fullData.first_name
    this.lastname = this.fullData.last_name
    this.phonenumber = this.fullData.phone_number
    this.email1 = this.fullData.email
    this.username = this.fullData.username
    this.imageURL = this.fullData.image_path
    this.s3url = this.fullData.image_path
    
  //   if (this.fullData.image_path &&this.fullData.image_path.length !== 0) {
  //     this.showOverlay=false
  //   this.imageURL = this._shared.getImageUrl('d2c-crm', this.fullData.image_path);
  // } else {
  //     this.showOverlay=false
  //     this.imageURL = 'assets/images/multi-user.jpg';}
    // this.imageURL = this._shared.getImageUrl('d2c-crm', this.fullData.image_path);
    this.initform();

  }
  initform(){
    this.updateform = this.formBuilder.group({
      email: ['', [Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      // password: ['', [Validators.required]],
      // username: ['', [Validators.required]],
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      phone_number: ['', [Validators.required]],
      image_path:['']
    });
  }

  numericOnly(event): boolean {    
    let patt = /^[0-9 .]+$/;
    let result = patt.test(event.key);
    return result;
  }
  onSubmit() {
    this.showOverlay=true;
    let data = this.updateform.value
    data['image_path'] = this.s3url
    this.authService.update_profile(data).subscribe((res: any) => {
      let mes=JSON.parse(res)
      res = mes
      if(mes.statusCode === 201){
        this.toastr.success(mes.success, 'Success')
        this.showOverlay=false
        this.router.navigate(['/page/retailripple/profile'])
      }
      else {
        if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
          this.authService.logout1()
          this.showOverlay=false
          this.router.navigate(['/auth/login'])
        }
        else{
          this.toastr.error(mes.error, "");
          this.showOverlay = false; 
        }
      }
     
    })
     
    
  }


  // fileChange(event: any) {
  //   this.showOverlay = true;
  //   let fileList: any = (event.target as HTMLInputElement);
  //   let file: File = fileList.files[0];
    
  
  //   if (file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'image/jpg') {
  //     this.toastr.error("Uh-oh! We only accept PNG, JPG, or JPEG images. Please upload a file in one of these formats");
  //     this.showOverlay = false;

  //     return;
  //   }

  
  //   this.selectedFile = fileList.files[0];
  //   // console.log(this.selectedFile,'selectedfile')
  //   this.s3Upload(this.selectedFile);
  
  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     this.imageURL = reader.result as string;
  //     (document.getElementById('companylogo-img') as HTMLImageElement).src = this.imageURL;
  //   };
  //   reader.readAsDataURL(file);
  
  // }

  async s3Upload(file:any ){ 
    
    let bucketName = 'd2c-crm'
    let FolderName = `profile-image`
    try {
      let data = await this._shared.UploadFileToS3(bucketName,FolderName,file);
      // console.log(data,'data2')
      this.showOverlay=false 
      this.img_path=data.Key 
      // console.log(data,'data1')
      this.updateform.get('image_path').setValue(this.img_path);
      return data;
    } catch (error) {
      // console.error(error);
      this.showOverlay=false 
    }
  }

  albhabetsOnly(event:any): boolean {    
    let patt = /^[a-z A-Z]+$/;
    let result = patt.test(event.key);
    return result;
  }
  s3url:any



  fileChange(event: any) {
    this.showOverlay = true; // Show overlay while uploading

    let fileList: FileList = (event.target as HTMLInputElement).files!;
    if (!fileList.length) return;

    let file: File = fileList[0]; // Get the selected file
    const roomName = 'room123'; // Dynamic Room Name
    const fileExtension = file.name.split('.').pop(); // Extract file extension

    // 🔹 Construct S3 upload URL
    const s3UploadUrl = `https://d2c-crm.s3.ap-south-1.amazonaws.com/d2c-crm/profile-image/${file.name}`;
    this.s3url = s3UploadUrl

    const reader = new FileReader();
    reader.onload = () => {
      this.imageURL = reader.result as string;
      (document.getElementById('companylogo-img') as HTMLImageElement).src = this.imageURL;
    };
    reader.readAsDataURL(file);

    // 🔹 Upload File to S3
    this.uploadFileToS3(s3UploadUrl, file);
  }

  uploadFileToS3(uploadUrl: string, file: File) {
    const headers = new HttpHeaders({
      'Content-Type': file.type,
    });
    console.log(uploadUrl,headers,'uploadUrl');
    

    this.http.put(uploadUrl, file, { headers }).subscribe(
      (response) => {
        console.log('✅ File uploaded successfully!', response);
        this.showOverlay = false; // Hide overlay after upload
      },
      (error) => {
        console.error('❌ Error uploading file:', error);
        this.showOverlay = false; // Hide overlay on error
      }
    );
  }

}
